/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type YearlyEventVisibility = typeof YearlyEventVisibility[keyof typeof YearlyEventVisibility];


export const YearlyEventVisibility = {
  Hidden: 'Hidden',
  Visible: 'Visible',
  VisibleWithYear: 'VisibleWithYear',
} as const;
